import axios from 'axios';
import PublishedAtInfo from '../utils/PublishedAtInfo';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import API_BASE_URL from '../../config';
import FeaturedImage from './FeaturedImage';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

interface Comment {
  author: string;
  content: string;
  posted_at?: Date;
}

export type ArticleType = {
  _id: string;
  subheading?: string;
  title: string;
  video?: string | null;
  content?: string | null;
  image: string | null;
  published: boolean;
  published_at: string;
  imageURL: string;
  comments: Comment[];
};

const PublishedArticlePreview: React.FC = () => {
  const [data, setData] = useState<ArticleType | null>(null);
  const location = useLocation();
  const { state } = location;
  const url = `/article/${state.article._id}/show`;
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const configuration = {
          url: API_BASE_URL + url,
          method: 'get',
          headers: {
            'Content-Type': 'application/json',
          },
        }

        axios.request<ArticleType>(configuration).then(
          (res: any) => {
            setData({
              ...res.data['article'][0],
              imageURL: res.data['imageURL'],
              comments: res.data['article'][0].comments || []
            });
          }
          ).catch((err) => {
            console.error(err);
        });

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [url]);

  return (
    <div className="font-poppins container my-2 mx-auto md:px-6">
      <div className="flex justify-end">      
        <Link 
          className="fixed top-4 right-4 z-50 rounded-md bg-black px-3 py-1.5 text-sm font-semibold text-white shadow-sm 
                    hover:bg-gray-300 hover:text-black 
                    focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-500"
          to="/dashboard">
          {t('GoBack')}
        </Link>
      </div>
      <section className="mb-32">
        {
          data?.imageURL && (
            <div className='flex justify-start max-w-full sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl mx-auto'>
              <FeaturedImage
                imageURL={data.imageURL}
                />
            </div>
            )
        }

        <div className="mb-6 flex items-center">
          <PublishedAtInfo published_at={String(state.article.published_at)} ></PublishedAtInfo>
        </div>

        <h1 className="mb-6 text-3xl font-bold">
          {data?.title}
        </h1>

        <h4 className="mb-6 text-2xl">
          {data?.subheading}
        </h4>

        <h1 className="mb-6 text-3xl font-bold">
          <div dangerouslySetInnerHTML={{ __html: data?.video || 'No hay video' }} />
        </h1>

        <p>
          <div dangerouslySetInnerHTML={{ __html: `${data?.content}` }} />
        </p>
      </section>
    </div>
  )
}

export default PublishedArticlePreview
